import React from 'react';

interface IconEquipmentProps {
    iconClasses?: string;
}

const IconEquipment: React.FC<IconEquipmentProps> = ({ iconClasses }) => {
    return (
        <svg
            width="30"
            height="30"
            viewBox="0 0 30 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={`icon icon-equipment ${iconClasses ?? ''}`}
        >
            <path
                d="M25.5 11.505V0L12.135 10.02C10.4344 8.39606 8.17143 7.49303 5.82 7.5H0V22.5H6V27H0V30H15V27H9V22.5H15V16.68C15.0037 15.1907 14.6432 13.7231 13.95 12.405L22.5 6V11.505L18.75 16.5H18V25.5H30V16.5H29.25L25.5 11.505ZM12 19.5H3V10.5H5.82C7.45904 10.5 9.03094 11.1511 10.1899 12.3101C11.3489 13.4691 12 15.041 12 16.68V19.5ZM24 14.505L25.5 16.5H22.5L24 14.505ZM27 22.5H21V19.5H27V22.5Z"
                fill="currentColor"
            />
        </svg>
    );
};

export default IconEquipment;
